var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.5 24.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1347",
    transform: "translate(-104 -939.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_877",
    transform: "translate(105 943.508)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_53",
    className: "cls-1",
    cx: 5.16,
    cy: 4.22,
    rx: 3.42,
    ry: 3.22
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_418",
    className: "cls-1",
    d: "M13.26,15.88c-4.71-2.36-4.71-6.6-8.48-6.6-2.06,.05-3.73,1.71-3.77,3.77v10.84h7.54v-7.54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    className: "cls-1",
    cx: 23.29,
    cy: 4.22,
    r: 3.22
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_419",
    className: "cls-1",
    d: "M15.24,15.88c4.71-2.36,4.71-6.6,8.49-6.6,2.06,.05,3.73,1.71,3.77,3.77v10.84h-7.54v-7.54"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.5ec7a295fa6f172fa144d44b2783c808.svg";
export { ForwardRef as ReactComponent };